export default "__VITE_ASSET__c0c2ce0c__"